import React, { useEffect, useState } from "react";
import ProfileImage from "./ProfileImage";
import HairdresserCard from "./HairdresserCard";
import styles from "./HairdresserList.module.css";
import { Link } from "react-router-dom";
import { getPartners, getTimesheet } from "../../services/server-actions";
import { StoreService } from "../../services/store-service";
import { DateTime } from "ts-luxon";

interface Partner {
  id: number;
  firstname: string;
  lastname: string;
  firstFreeTime: string | null;
  logo: string;
}

const processImage = (profileData: string | undefined): string => {
  return profileData ? profileData : "";
};

interface HairdresserListProps {
  searchQuery: string;
}

const HairdresserList: React.FC<HairdresserListProps> = ({ searchQuery }) => {
  const [partners, setPartners] = useState<Partner[]>([]);
  const [status, setStatus] = useState<"loading" | "error" | "success">(
    "loading"
  );

  useEffect(() => {
    const fetchPartnersAndFirstTimes = async () => {
      setStatus("loading");

      try {
        let storedPartners = StoreService.GetData("partners");

        if (!storedPartners || !Array.isArray(storedPartners)) {
          const fetchedPartners = await getPartners();
          storedPartners = fetchedPartners.map((partner: any) => ({
            id: partner.id,
            firstname: partner.firstname ?? "نامشخص",
            lastname: partner.lastname ?? "نامشخص",
            firstFreeTime: null,
            logo: processImage(partner.profile),
          }));
          StoreService.SetData("partners", storedPartners);
        }

        const updatedPartners = await Promise.all(
          storedPartners.map(async (partner: Partner) => {
            let firstAvailableDate: string | null = null;

            // چک کردن ۳۰ روز آینده
            for (let i = 0; i < 30; i++) {
              const dateToCheck = DateTime.local()
                .plus({ days: i })
                .toISODate()!;
              const timesheet = await getTimesheet(
                dateToCheck,
                undefined,
                partner.id
              );

              if (timesheet && timesheet.length > 0) {
                firstAvailableDate = dateToCheck;
                break;
              }
            }

            return {
              ...partner,
              firstFreeTime: firstAvailableDate,
            };
          })
        );

        setPartners(updatedPartners);
        setStatus("success");
      } catch (err) {
        console.error("Error fetching partners or timesheets:", err);
        setStatus("error");
      }
    };

    fetchPartnersAndFirstTimes();
  }, []);

  const filteredPartners = partners.filter(({ firstname, lastname }) =>
    `${firstname} ${lastname}`.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <Link to="/DresserList" className={styles.viewAllLink}>
          مشاهده همه
        </Link>
        <h5 className={styles.headerTitle}>آرایشگرها</h5>
      </header>

      {status === "loading" ? null : status === "error" ? (
        <p className="text-center text-danger">
          خطا در دریافت اطلاعات آرایشگرها!
        </p>
      ) : (
        <div className={`${styles.scrollContainer} ${styles.customScrollbar}`}>
          {filteredPartners.map(
            ({ id, logo, firstname, lastname, firstFreeTime }) => (
              <div key={id} className={styles.card}>
                <ProfileImage image={logo} size={68} partnerId={id} />
                <Link to={`/times?partnerId=${id}&stylist=${encodeURIComponent(firstname + " " + lastname)}&date=${firstFreeTime ?? ""}`} className="text-decoration-none">

                  <HairdresserCard
                    title="آرایشگر"
                    firstname={firstname}
                    lastname={lastname}
                    firstFreeTime={firstFreeTime}
                    availability="نامشخص"
                    id={id}
                  />
                </Link>
              </div>
            )
          )}
        </div>
      )}
    </div>
  );
};

export default HairdresserList;
